
import $ from 'jquery';

import { debounce, isMobile } from '../../utils';

$(function () {

    var $body = $('body');
    var $header = $('.header');
    var $navItems = $header.find('.primary-nav__item');
    var $navLinks = $header.find('.primary-nav__list a');
    var $navToggle = $header.find('.primary-header__toggle');
    var $subnavToggles = $header.find('.subnav-toggle');
    var $tertiaryHeader = $header.find('.tertiary-header');
    var $tertiaryToggles = $body.find('[data-tertiary-toggle]');

    var isTertiaryOpen = false;

    init();

    $(window).on('resize', debounce(onResize, 200));
    $('#skip-content').on("click", (e) => {
        e.preventDefault();
        var mainContent = document.querySelector('#main-content')
        if (mainContent) {
            mainContent.focus()
            mainContent.scrollIntoView({ behavior: 'smooth', })
        }
    })

    ////

    function bindEvents() {
        !isMobile() && $body.on('click', checkBodyClickForHeader);
        $navToggle.on('click touch', togglePrimaryNav);
        $subnavToggles.on('click touch', toggleSubNav);
        $tertiaryToggles.on('click touch', toggleTertiaryNav);
    }

    function checkBodyClickForHeader(event) {
        var $target = $(event.target);

        var $parent = $target.closest('.header');

        if (isTertiaryOpen && !$parent.length) {
            toggleTertiaryNav(event);
        }
    }

    function init() {
        $navLinks.each(toggleActiveNavItem);

        bindEvents();
    }

    function onResize() {
        unbindEvents();

        $tertiaryHeader = $header.find('.tertiary-header');
        $tertiaryToggles = $body.find('[data-tertiary-toggle]');

        $body.removeClass('overflow-hidden');
        $header.removeClass('active');
        $navItems.removeClass('active');
        $tertiaryHeader.removeClass('active');
        $tertiaryToggles.removeClass('active');

        bindEvents();
    }

    function toggleActiveNavItem(index, navItem) {
        var $navItem = $(navItem);

        var action = $navItem.data('action');
        var area = $navItem.data('area');
        var isActive = false;

        if (area === window.routeData.area && action === window.routeData.action) {
            isActive = true;
        }

        if (isActive) {
            $navItem.addClass('current');
            $navItem.next().addClass('current');
        } else {
            $navItem.removeClass('current');
            $navItem.next().removeClass('current');
        }
    }

    function togglePrimaryNav() {
        $header.toggleClass('active');

        if (isMobile()) {
            $body.toggleClass('overflow-hidden');
        }
    }

    function toggleSubNav() {
        var $toggle = $(this);

        var $navItem = $toggle.closest('.primary-nav__item');

        $navItem.toggleClass('active');
    }

    function toggleTertiaryNav() {
        var $toggle = $(this);

        event.preventDefault();
        event.stopPropagation();

        $tertiaryHeader.toggleClass('active');
        $toggle.toggleClass('active');

        isTertiaryOpen = $tertiaryHeader.hasClass('active');
    }

    function unbindEvents() {
        $body.off('click', checkBodyClickForHeader);
        $navToggle.off('click', togglePrimaryNav);
        $subnavToggles.off('click touch', toggleSubNav);
        $tertiaryToggles.off('click touch', toggleTertiaryNav);
    }

});
